import { Actor } from './actor';
import { Location } from './location';
import { MobileBaseObject } from "./mobile-base-object";
import { Availability } from './availability';

export interface IActivityActor extends MobileBaseObject {
  state: string;
  dateKey: string;
  actorID: string;
  actor: Actor;
  startLocationID: string;
  startLocation: Location;
  endLocationID: string;
  endLocation: Location;
  userMappingID: string;
  availabilityID: string;
  start: Date;
  duration: string;
  status: string;
  description: string;
  comment: string;
  modifiedBy: string;
  started: Date;
  ended: Date;
  availability: Availability;
}

export class ActivityActor extends MobileBaseObject implements IActivityActor {

  public state: string;
  public dateKey: string;
  public actorID: string;
  public actor: Actor;
  public startLocationID: string;
  public startLocation: Location;
  public endLocationID: string;
  public endLocation: Location;
  public userMappingID: string;
  public availabilityID: string;
  public start: Date;
  public duration: string;
  public status: string;
  public description: string;
  public comment: string;
  public modifiedBy: string;
  public started: Date;
  public ended: Date;
  public availability: Availability;

  public constructor(
    activityActor: Partial<IActivityActor>
  ) {
    super();

    this.state = activityActor.state;
    this.dateKey = activityActor.dateKey;
    this.actorID = activityActor.actorID;
    this.startLocationID = activityActor.startLocationID;
    this.endLocationID = activityActor.endLocationID;
    this.userMappingID = activityActor.userMappingID;
    this.availabilityID = activityActor.availabilityID;
    this.start = activityActor.start ? new Date(new Date(activityActor.start).getTime()) : activityActor.start;
    this.duration = activityActor.duration;
    this.status = activityActor.status;
    this.description = activityActor.description;
    this.comment = activityActor.comment;
    this.modifiedBy = activityActor.modifiedBy;
    this.started = activityActor.started ? new Date(activityActor.started) : activityActor.started;
    this.ended = activityActor.ended ? new Date(activityActor.ended) : activityActor.ended;
    this.availability = activityActor.availability;

    this.startLocation = activityActor.startLocation;
    this.endLocation = activityActor.endLocation;
    this.actor = activityActor.actor ? new Actor(activityActor.actor) : activityActor.actor;

    this.id = activityActor.id;
    this.createdAt = activityActor.createdAt ? new Date(activityActor.createdAt) : activityActor.createdAt;
    this.updatedAt = activityActor.updatedAt ? new Date(activityActor.updatedAt) : activityActor.updatedAt;
  }

  public get durationMinutes(): number {
    var datetime = new Date('1970-01-01T' + this.duration + 'Z');
    return (datetime.getTime() / 1000 / 60);
  }
  public set durationMinutes(value: number) {
    var end = new Date('1970-01-01T00:00:00Z');;
    this.duration = formatTime(new Date(end.getTime() + (end.getTimezoneOffset() * 60 * 1000) + (value * 60 * 1000)));
  }

  public get end(): Date {
    var datetime = new Date('1970-01-01T' + this.duration + 'Z');
    return (new Date(this.start.getTime() + datetime.getTime()));
  }
  public set end(value: Date) {
    this.duration = formatDiffTime(this.start, value);
  }

}

const leadingZero = (num) => `0${num}`.slice(-2);

const formatDiffTime = (start: Date, end: Date) =>
  [end.getHours() - start.getHours(), end.getMinutes() - start.getMinutes(), end.getSeconds() - start.getSeconds()]
    .map(leadingZero)
    .join(':') + ".0000000";

const formatTime = (date: Date) =>
  [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map(leadingZero)
    .join(':') + ".0000000";

